<template>
    <!--DesignatedPersonsDetailsDialog-->
    <div>
        <!-- Sender -->
        <div v-if="showSenderSection">
            <div class="col-sm-6 col-md-12 pl-0 pr-0">
                <label class="label_required">{{ $t("res_Label_Sender") }} *</label>
                <div class="with-absolute-button">
                    <StructureUserSelector :showInternalUsers="false" :showExternalUsers="false"
                                           :showInternalStructures="categoryId != 1"
                                           :showExternalStructures="categoryId == 1" :excludeSelf="true"
                                           :isMultiple="false"
                                           :selectedStructureUser="selectedSenderStructure"
                                           :addressBook_header="$t('res_Label_SelectSender')"
                                           @structureUserSelectChanged="(dynamicListObject) => handleSelectedItems('senderStructure',dynamicListObject)">
                    </StructureUserSelector>
                </div>
            </div>
            <!--Designated Person For Sender-->
            <div class="col-md-12 pl-0 pr-0" v-if="categoryId == 1 || constants.client_version_Id=='ADFD'">
                <label>{{ $t("res_Label_DesignatedPersonFrom") }}</label>
                <div class="d-flex align-items-center">
                    <div class="flex-1 with-absolute-button">
                        <multi-select class="light-bg" v-model="selectedSendingDesignatedPerson"
                                      label="name" track-by="id" open-direction="bottom"
                                      :options="sendingDesignatedPersonsList" :searchable="true" :loading="loading.firstDesignatedSelector"
                                      :internal-search="false" :clear-on-select="false" :close-on-select="true"
                                      :options-limit="300" :max-height="600" :show-no-results="false"
                                      :hide-selected="false" :multiple="false"
                                      @input="(dynamicListObject) => handleSelectedItems('sendingDesignatedPerson',dynamicListObject)"
                                      @search-change="(searchValue) => getDesignatedPersons('Sender',searchValue,[],false,[],false,2,false,true)"
                                      @close="sendingDesignatedPersonsList = []" :placeholder="$t('res_Label_SelectOption')">
                            <template slot="option" slot-scope="props">
                                <div class="mt-1" style="width: 100%; display: flex;text-align:start; ">
                                    <div class="" style="">
                                        <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                    </div>
                                    <div class="ad__box">
                                        <p class="ad__text__bold">{{ props.option.name }}</p>
                                    </div>
                                </div>
                            </template>
                            <template slot="noOptions" slot-scope="props">
                                <div style="text-align:start">
                                    {{ $t("res_Msgs_EmptySearch") }}
                                </div>
                            </template>
                        </multi-select>
                    </div>
                    <div class="px-3">
                        <button @click="openDesignatedPersonsDetailsDialog('Sender')">
                            <v-icon color="#205CDF">mdi-contacts</v-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-------------------------------------------------------------------------------------------------------------------------------------->
        <!-- Recipient -->
        <div v-if="showRecipientSection">
            <div class="col-sm-6 col-md-12 pl-0 pr-0">
                <label class="label_required">{{ $t("res_Label_Recipient") }} *</label>
                <div class="d-flex align-items-center">
                    <div class="flex-1 with-absolute-button">
                        <StructureUserSelector :showInternalUsers="false" :showExternalUsers="false"
                                               :showInternalStructures="categoryId != 2"
                                               :showExternalStructures="categoryId == 2"
                                               :excludeSelf="true" :isMultiple="categoryId != 1"
                                               :selectedStructureUsersList="selectedRecipientStructures"
                                               :selectedStructureUser="selectedRecipientStructures"
                                               @structureUserSelectChanged="(dynamicListObject) => handleSelectedItems('recipientStructures',dynamicListObject)"
                                               :addressBook_header="$t('res_Label_SelectRecipient')">
                        </StructureUserSelector>
                    </div>
                </div>
            </div>
            <!--Designated Person For Recipients-->
            <div class="col-md-12 pl-0 pr-0">
                <label>{{ $t("res_Label_DesignatedPerson") }}</label>
                <div class="d-flex align-items-center">
                    <div class="flex-1 with-absolute-button">
                        <multi-select class="light-bg" v-model="selectedRecipientDesignatedPersons"
                                      label="name" track-by="id" open-direction="bottom"
                                      :options="recipientDesignatedPersonsList" :searchable="true" :loading="loading.SecondDesignatedSelector"
                                      :internal-search="false" :clear-on-select="false" :close-on-select="true"
                                      :options-limit="300" :max-height="600" :show-no-results="false"
                                      :hide-selected="false" :multiple="categoryId != 1" ref="multiselect1"
                                      @input="(dynamicListObject) => handleSelectedItems('recipientDesignatedPersons',dynamicListObject)"
                                      @search-change="(searchValue) => getDesignatedPersons('Recipient',searchValue,[],false,[],false,2,false,true)"
                                      @close="recipientDesignatedPersonsList = []" :placeholder="$t('res_Label_SelectOption')">
                            <template slot="option" slot-scope="props">
                                <div style="height: 50px; width: 100%; display: flex; text-align: start; ">
                                    <div class="" style="">
                                        <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                    </div>
                                    <div class="ad__box">
                                        <p class="ad__text__bold">{{ props.option.name }}</p>
                                    </div>
                                </div>
                            </template>
                            <template slot="noOptions" slot-scope="props">
                                <div style="text-align:start">
                                    {{ $t("res_Msgs_EmptySearch") }}
                                </div>
                            </template>
                        </multi-select>
                    </div>
                    <div class="px-3">
                        <button @click="openDesignatedPersonsDetailsDialog('Recipient')">
                            <v-icon color="#205CDF">mdi-contacts</v-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-------------------------------------------------------------------------------------------------------------------------------------->
        <!--Designated Persons PopUp - Arrows-->
        <v-dialog v-model="showDesignatedPersonsDetailsDialog" :persistent="true"
                  content-class="designated-persons-dialog fullscreen-dialog dialog with-fixed-actions bg-white" fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <div class="custom-icon-wrapper">
                        <v-icon @click="closeDesignatedPersonsDialog()">custom-icon left-arrow-icon</v-icon>
                    </div>
                    <h1 class="mb-0">{{ $t("res_DialogTitle_ChooseDesignatedPersons") }}</h1>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="closeDesignatedPersonsDialog()">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <!--New Design-->
            <div class="cursor-pointer" v-for="(structure, index) in dialogStructuresList" v-if="structure.id > 0">
                <div class="bg-gray mt-3 p-3 rounded-3d-flex rounded-3 position-relative mr-3 ml-3" @click="openStructure(index)">
                    <div class="d-flex">
                        <button class="icon-button" :class="{ 'mr-5': lang == 'en' || lang == null, 'ml-5': lang == 'ar' }">
                            <v-icon v-if="lang == 'en' || lang == null">{{ structure.isOpen == true ? 'mdi-menu-down' : 'mdi-menu-right' }}</v-icon>
                            <v-icon v-if="lang == 'ar'">{{ structure.isOpen == true ? 'mdi-menu-down' : 'mdi-menu-left' }}</v-icon>
                        </button>
                        <span class="size-16">{{structure.name}} </span>
                    </div>
                </div>
                <!--Children-->
                <!--Header-->
                <div v-if="structure.isOpen == true" class="mt-4" :class="{ 'ml-10 mr-4': lang == 'en' || lang == null, 'mr-10 ml-4': lang == 'ar' }">
                    <div class="d-flex mt-3 bg-gray text-white rounded-3" style="background-color: #7DA1C4">
                        <span style="width:40px"></span>
                        <span class="col-xl">{{$t("res_Label_FirstName")}}</span>
                        <span class="col-xl">{{$t("res_Label_MiddleName") }}</span>
                        <span class="col-xl">{{$t("res_Label_LastName") }}</span>
                        <span class="col-xl">{{$t("res_Label_Email") }}</span>
                        <span class="col-xl">{{$t("res_Label_Title") }}</span>
                        <span class="col-xl">{{$t("res_Label_Profession")}}</span>
                        <div class="p-2 d-flex justify-center" style="width:75px">
                            <button v-if="constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.CreateDesignatedPerson.key)" @click="showAddEditDialog(null,structure.id)"><v-icon>mdi-plus-circle</v-icon></button>
                            <button v-else><v-icon></v-icon></button>
                        </div>
                    </div>
                    <div v-if="doesStructureHavePersons(structure.id) == false" class="justify-content-center d-flex m-2 mt-6 rounded-3 ml-14">
                        <span class="align-items-center weight-500">{{ $t("res_Label_NoData") }}</span>
                    </div>
                    <!--Data Of children-->
                    <div v-if="dialogDesignatedPersonsList != null && dialogDesignatedPersonsList.length > 0 && person.structureId == structure.id"
                         class="d-flex rounded-3"
                         v-for="(person,index) in dialogDesignatedPersonsList">
                        <span class="d-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                            <v-checkbox @click="handleDesignatedPersonCheckboxClick(person)" v-model="person.isSelected" class="bg-white"></v-checkbox>
                        </span>
                        <span class="col-xl text-cut">{{ lang == 'en' ? person.firstName :person.firstNameAr }}</span>
                        <span class="col-xl text-cut">{{ lang == 'en' ? person.middleName : person.middleNameAr }}</span>
                        <span class="col-xl text-cut">{{ lang == 'en' ? person.lastName : person.lastNameAr }}</span>
                        <span class="col-xl text-cut">{{ person.email}}</span>
                        <span class="col-xl text-cut">{{ lang == 'en' ? person.title : person.titleAr }}</span>
                        <span class="col-xl text-cut">{{ lang == 'en' ? person.profession : person.professionAr }}</span>
                       
                        <div class="custom-icon-wrapper"  v-if="constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.CreateDesignatedPerson.key)" style="width:75px">
                              <v-icon  @click="openDeleteDialog(person)">custom-icon white-bg delete-icon</v-icon>
                        </div>
                        <div v-else class="p-2 d-flex justify-center" style="width:75px"></div>

                        <div v-if="constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.CreateDesignatedPerson.key)" class="p-2 d-flex justify-center" style="width:75px">
                            <button class=""
                                    @click="showAddEditDialog(person)">
                                <v-icon class="light">mdi-pencil</v-icon>
                            </button>

                          
                        </div>
                         <div v-else class="p-2 d-flex justify-center" style="width:75px"></div>
                 
                    </div>
                </div>
            </div>
            <div v-if="dialogStructuresList.length == 0" class="justify-content-center d-flex m-2 mt-6 rounded-3">
                <h4 class="align-items-center weight-500">{{ $t("res_Label_NoData") }}</h4>
            </div>
            <div class="d-flex footer justify-content-end mt-auto">
                <div class="m-4">
                    <v-btn class="dgs-new-button mr-3" @click="closeDesignatedPersonsDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn class="primary" @click="saveSelectedDesignatedPersonsDialog()">{{ $t("res_ButtonText_Save") }}</v-btn>
                </div>
            </div>
        </v-dialog>

        <!--showAddEditDesignatedPersonDialog-->
        <v-dialog v-model="showAddEditDesignatedPersonDialog" :persistent="true" content-class="large-dialog" width="800" height="1150">
            <v-card>
                <v-card-title>
                    {{ addEditResource }}
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_Label_FirstName") }} * </label>
                                <v-text-field v-model="designatedPerson.firstName" label="" solo></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_Label_MiddleName") }}</label>
                                <v-text-field v-model="designatedPerson.middleName" label="" solo></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_Label_LastName") }} * </label>
                                <v-text-field v-model="designatedPerson.lastName" label="" solo></v-text-field>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_Label_FirstNameAr") }} </label>
                                <v-text-field v-model="designatedPerson.firstNameAr" label="" solo></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_Label_MiddleNameAr") }} </label>
                                <v-text-field v-model="designatedPerson.middleNameAr" label="" solo></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_Label_LastNameAr") }} </label>
                                <v-text-field v-model="designatedPerson.lastNameAr" label="" solo></v-text-field>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_Label_Email") }}</label>
                                <v-text-field v-model="designatedPerson.email" label="" solo></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_Label_Title") }}</label>
                                <v-text-field v-model="designatedPerson.title" label="" solo></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_Label_TitleAr") }}</label>
                                <v-text-field v-model="designatedPerson.titleAr" label="" solo></v-text-field>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_GridHeaders_Profession") }} </label>
                                <v-text-field v-model="designatedPerson.profession" label="" solo></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_GridHeaders_ProfessionAr") }} </label>
                                <v-text-field v-model="designatedPerson.professionAr" label="" solo></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_Label_IsDefaultDesignated") }} </label>
                                <v-checkbox v-model="designatedPerson.isDefaultDesignatedPerson"></v-checkbox>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <div class="mt-2">
                                <label>{{ $t("res_GridHeaders_Salutation") }} </label>
                                <v-text-field v-model="designatedPerson.salutation" label="" solo></v-text-field>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" style="min-width: 100px !important;"
                           @click="closeAddEditDesignatedPersonsDialog();">
                        {{ $t("res_ButtonText_Cancel") }}
                    </v-btn>
                    <v-btn class="primary" style="min-width: 100px !important;"
                           @click="addEditDesignatedPerson()">
                        {{ $t("res_ButtonText_Save") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import StructureUserSelector from '@/components/StructureUserSelector.vue'
    import MultiSelect from 'vue-multiselect'
    import * as utils from '@/assets/js/common.js'
    import axios from 'axios'
    import constants from '@/assets/js/constants.js'

    export default {
        name: 'RecipientSenderSelector',
        components: { StructureUserSelector, MultiSelect },
        data: function () {
            return {
                utils: utils,
                lang: localStorage.getItem('lang') != null && localStorage.getItem('lang') != undefined ? localStorage.getItem('lang') : 'en',
                //----------------------------- Selected Data --------------------------------
                selectedSenderStructure: null,
                selectedSendingDesignatedPerson: null,

                selectedRecipientStructures: [],
                selectedRecipientDesignatedPersons: [],
                //----------------------------- Store Items Of DesigatedPersons For Sender and Recipient -----
                sendingDesignatedPersonsList: [],
                recipientDesignatedPersonsList: [],
                showCCBlock: false,
                loading: {
                    firstDesignatedSelector: false,
                    SecondDesignatedSelector: false
                },
                //------------------------------Designated Persons Dailog Data-----------------
                dialogStructuresList: [],
                dialogDesignatedPersonsList: [],
                dialogMode: Number,
                designatedPerson: { structureId: 0 },
                addEditResource: "",
                showAddEditDesignatedPersonDialog: false,
                allSelectedDesignatedPersonsCheckbox: [],
                showDesignatedPersonsDetailsDialog: false,
                constants: constants,
                forStructureDialogMode: '', // 'Sender', 'Recipient'
                ignoreReset: false
            };
        },
        props: {
            currentStructureId: null,
            sendingEntityId: null,
            senderDesignatedPersonsId: null,
            receiversAndDesignatedPersons: null,
            categoryId: Number,
            showSenderSection: { type: Boolean, default: true },
            showRecipientSection: { type: Boolean, default: true },
        },
        mounted () 
        {
            if (this.sendingEntityId != null && this.sendingEntityId != undefined)
                this.addMissingStructures("firstInitiateForSenderStructure", [this.sendingEntityId]);
            else
            {
                // default sender to current structure for all categories except incoming
                if (this.categoryId != 1 && !utils.CheckIfNullOrEmpty(this.currentStructureId))
                    this.addMissingStructures("firstInitiateForSenderStructure", [this.currentStructureId]);
            }

            if (this.senderDesignatedPersonsId != null && this.senderDesignatedPersonsId != undefined)
                this.getDesignatedPersons("Sender", '', [], false, [this.senderDesignatedPersonsId], true);

            if (this.receiversAndDesignatedPersons != null && this.receiversAndDesignatedPersons != undefined) 
            {
                 try {
                    this.receiversAndDesignatedPersons = JSON.parse(this.receiversAndDesignatedPersons);
                         } catch (error) {
                         }
                if (Array.isArray(this.receiversAndDesignatedPersons))
                 {
                    let structureIds = this.receiversAndDesignatedPersons.map(item => item.StructureId);
                    this.addMissingStructures('recipientDesignatedPersons', structureIds, true)
                }

                //Get persons ..
                if (Array.isArray(this.receiversAndDesignatedPersons)) 
                {
                    let personsIds = this.receiversAndDesignatedPersons.map(item => item.DesignatedPersonId);
                    personsIds = personsIds.filter(id => id != undefined && id > 0);
                    if (personsIds.length > 0)
                        this.getDesignatedPersons('Recipient', '', '', false, personsIds, true);
                }
            }
            else
            {
                // default recipient to current structure for incoming, circular, decree categories
                if ((this.categoryId == 1 || this.categoryId == 4 || this.categoryId == 5) && !utils.CheckIfNullOrEmpty(this.currentStructureId))
                    this.addMissingStructures("recipientDesignatedPersons", [this.currentStructureId]);
            }
        },
        watch:
        {
            // Later, We Will Handle Any Detection Cases - byYazan
        },
        methods:
        {
            // ------------------- Sender - Recipient handled Methods ----------------- //
            getDesignatedPersons(forStructure = '', searchValue = '', structureIds = [], isForDefaultItem = false, personsIds = [], isForInitiate = false, InternalExternalBothCase, getAll = false,getActiveUsers = false) 
            {
                if (forStructure != 'dialogMode')
                    InternalExternalBothCase = this.handleInternalExternalDesignatedPersonsCases(forStructure, InternalExternalBothCase);

                this.categoryId == 1 ? this.loading.firstDesignatedSelector = true : this.loading.secondDesignatedSelector = true;  // handle Loading animation

                axios.get(constants.baseApiUrl + 'Document/GetDesignatedPersons?structureIds=' + structureIds.toString()
                                                + '&search=' + searchValue + '&personsIds=' + personsIds.toString() + '&selectExternal=' + InternalExternalBothCase
                                                + '&getAll=' + getAll +'&getActiveUsers='+getActiveUsers)
                    .then((res) => 
                    {
                        this.sendingDesignatedPersonsList = []
                        this.recipientDesignatedPersonsList = []
                        
                        if ((res.data == null || res.data.length == 0) && forStructure != 'dialogMode')
                            return;
                        
                        this.handleDesignatedPersonsData(res.data, forStructure, isForDefaultItem, isForInitiate);
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.categoryId == 1 ? this.loading.firstDesignatedSelector = false : this.loading.secondDesignatedSelector = false);
            },
            handleInternalExternalDesignatedPersonsCases(forStructure) 
            {
                // 0 => internal , 1 => External , 1 => Both
                let InternalExternalBothCase = 2
                if (forStructure == 'Sender') 
                {
                    switch (this.categoryId) 
                    {
                        case 1:
                            InternalExternalBothCase = 1;
                            break;
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            if (constants.client_version_Id == 'ADFD')
                                InternalExternalBothCase = 0;
                                break;
                    }
                }
                else if (forStructure == 'Recipient') 
                {
                    switch (this.categoryId) 
                    {
                        case 1:
                            InternalExternalBothCase = 0
                            break;
                        case 2:
                            InternalExternalBothCase = 1
                            break;
                        case 3:
                        case 4:
                        case 5:
                            InternalExternalBothCase = 0
                            break;
                    }
                }
                return InternalExternalBothCase;
            },
            handleDesignatedPersonsData(response, forStructure, isForDefaultItem, isForInitiate) 
            {          
                this.lang == 'en' ? response.forEach(item => item.name = item.firstName + ' ' + item.lastName) : response.forEach(item => item.name = item.firstNameAr + ' ' + item.lastNameAr);
                if (forStructure == 'Sender') 
                {
                    if (isForInitiate)
                        this.handleSelectedItems('sendingDesignatedPerson', response[0]);
                    else 
                    {
                        if (isForDefaultItem)
                            this.selectedSendingDesignatedPerson = response[0];
                        else
                            this.sendingDesignatedPersonsList = response;
                    }
                }
                else if (forStructure == 'Recipient') 
                {
                    if (isForInitiate) 
                    {
                        if (this.categoryId == 1)
                            this.selectedRecipientDesignatedPersons = response[0];
                        else 
                        {
                            this.selectedRecipientDesignatedPersons = response;
                            this.selectedRecipientDesignatedPersons = utils.handleFirstElement(this.selectedRecipientDesignatedPersons, { id: -1, name: 'temp' });
                        }
                    }
                    else 
                    {
                       if (isForDefaultItem) 
                        {
                            response[0].Added = true;
                            if (this.categoryId == 1)
                                this.selectedRecipientDesignatedPersons = response[0];
                            else 
                            {
                                var selectedRecipientDesignatedPersonsList=this.selectedRecipientDesignatedPersons;
                                var defaultDesignatedPerson= response.filter(item => item.isDefaultDesignatedPerson==true);

                               
                                if(defaultDesignatedPerson.length>0){
                                        const index = response.findIndex(item => item.id === defaultDesignatedPerson[0].id); // Assuming each item has an `id` property
    
                                        if (index !== -1) {
                                            response[index].Added = true; // Set Added to true for the found index
                                        }


                                //check if DesignatedPerson allreary added
                                var personAdded= selectedRecipientDesignatedPersonsList.filter(item => item.id == response[index].id && item.structureId==response[index].structureId );
                                if(personAdded.length==0){this.selectedRecipientDesignatedPersons.push(response[index]);}
                                //this.selectedRecipientDesignatedPersons.push(response[0]);
                                }
                                this.selectedRecipientDesignatedPersons = utils.handleFirstElement(this.selectedRecipientDesignatedPersons, { id: -1, name: 'temp' });

                                //delete Duplicated Persons Related to Same Structure ..
                                this.selectedRecipientDesignatedPersons = this.deleteDuplicatedPersons_PerRecipientStructure(this.selectedRecipientDesignatedPersons);
                            }
                        }
                        else
                            this.recipientDesignatedPersonsList = response;
                    }
                }
                else if (forStructure == 'dialogMode')
                    this.handleDialogData(response);

                this.exportData();
            },
            handleSelectedItems(typeOfSelection = "", dynamic = null) 
            {  
                if (typeOfSelection == "")
                    return;

                if (typeOfSelection == "senderStructure") 
                {
                    this.selectedSenderStructure = dynamic;
                    if (this.categoryId == 1 || constants.client_version_Id == 'ADFD') 
                    {
                        this.deletePerson_RelatedToMissingSenderStructure(this.selectedSenderStructure.id);
                        this.addDefaultDesignatedPerson('Sender', this.selectedSenderStructure);
                    }
                }
                else if (typeOfSelection == "sendingDesignatedPerson") 
                {
                    let personObj = dynamic;
                    if (personObj != null && (this.selectedSenderStructure == null || this.selectedSenderStructure.id != personObj.structureId))
                        this.addMissingStructures(typeOfSelection, [personObj.structureId])

                    this.selectedSendingDesignatedPerson = personObj;
                }
                else if (typeOfSelection == "recipientStructures") 
                {
                    this.selectedRecipientStructures = dynamic;
                    const missingStructureIds = this.getMissingStructureIds(this.categoryId == 1 ? [dynamic] : dynamic);
                    if (missingStructureIds != null && missingStructureIds.length > 0)
                        this.deletePersons_RelatedToMissingRecipientStructures(missingStructureIds);

                    this.addDefaultDesignatedPerson('Recipient', dynamic);

                    if (this.categoryId != 1)
                    {
                        dynamic.forEach(item => item.Added = true);
                        this.selectedRecipientStructures = dynamic.filter(item => item.id > 0);
                        this.selectedRecipientStructures = utils.handleFirstElement(this.selectedRecipientStructures, { id: -1, name: 'temp' });
                        this.afterMapping();
                    }
                }
                else if (typeOfSelection == "recipientDesignatedPersons") 
                {
                    if (this.categoryId == 1) 
                    {
                        let personObj = dynamic;
                        if (personObj != null)
                            this.addMissingStructures(typeOfSelection, [personObj.structureId])
                    }
                    else
                        if (dynamic.length > 0) 
                        {  
                            //delete Duplicated Persons Related to Same Structure ..
                            dynamic = this.deleteDuplicatedPersons_PerRecipientStructure(dynamic);

                            const missingStructureIds = this.getMissingStructureIds();
                            if (missingStructureIds != null && missingStructureIds.length > 0)
                                this.addMissingStructures(typeOfSelection, missingStructureIds);

                            dynamic.forEach(item => item.Added = true);
                        }

                    this.selectedRecipientDesignatedPersons = dynamic;
                    this.afterMapping();
                }

                this.exportData();
            },
            getMissingStructureIds(strList) 
            {
                if (strList == undefined || strList == null || strList.length == 0)
                    strList = this.selectedRecipientStructures;

                let structuresIds = strList.map(structure => { if (structure.id > 0) return structure.id }).filter(id => id > 0);
                let personStructuresIds = this.categoryId == 1 ? [this.selectedRecipientDesignatedPersons] : this.selectedRecipientDesignatedPersons.map(person => { if (person.structureId > 0) return person.structureId }).filter(id => id > 0);

                const missingStructureIds = personStructuresIds.filter((personId) => !structuresIds.some((struId) => struId == personId));
                return missingStructureIds;
            },
            addDefaultDesignatedPerson(forStructure = '', dynamic) 
            {
                if (dynamic == null || dynamic == undefined)
                    return;

                if (forStructure == 'Sender')
                   // this.getDesignatedPersons(forStructure, '', [dynamic.id], true);
                   this.getDesignatedPersons(forStructure, '', [dynamic.id], true,[],false,2,false,true);
                else if (forStructure == 'Recipient') 
                {
                    if (this.categoryId == 1)
                        //this.getDesignatedPersons(forStructure, '', [dynamic.id], true);
                        this.getDesignatedPersons(forStructure, '', [dynamic.id], true,[],false,2,false,true);
                    else 
                    {
                        if (dynamic.length >= this.selectedRecipientStructures.length) 
                        {
                            let itemsNotInList = dynamic.filter(item => Number(item.id) > 0 && this.selectedRecipientStructures.some(selectedItem => selectedItem.id == Number(item.id))).map(x => Number(x.id));
                            itemsNotInList.forEach(id => 
                            {
                                //this.getDesignatedPersons(forStructure, '', [id], true);
                                this.getDesignatedPersons(forStructure, '', [id], true,[],false,2,false,true);
                            });
                        }
                    }
                }
            },
            addMissingStructures(typeOfSelection = "", structureIds, reset) 
            {
                if (typeOfSelection == "" || structureIds == null || structureIds == undefined)
                    return;

                if (structureIds.length > 0) 
                {
                    axios.get(constants.baseApiUrl + 'StructureUser/GetSelectedStructure?ids=' + structureIds.join(','), { headers: constants.headers })
                        .then(res => 
                        {
                            if (res.data != null && res.data.length > 0) 
                            {
                                res.data.forEach(str => str.id = str.id.toString());
                                if (typeOfSelection == "sendingDesignatedPerson" || typeOfSelection == "firstInitiateForSenderStructure") 
                                {
                                    this.selectedSenderStructure = res.data[0];
                                }
                                else if (typeOfSelection == "recipientDesignatedPersons") 
                                {
                                    if (this.categoryId == 1)
                                        this.selectedRecipientStructures = res.data[0];
                                    else 
                                    {
                                        if (reset)
                                            this.selectedRecipientStructures = [];
                                        let newListOfStructures = res.data;
                                        newListOfStructures.forEach(str => this.selectedRecipientStructures.push(str));
                                        this.selectedRecipientStructures = utils.handleFirstElement(this.selectedRecipientStructures, { id: -1, name: 'temp' });
                                    }
                                }
                                this.exportData();
                            }
                        })
                        .catch(err => console.warn(err))
                }
            },
            deletePerson_RelatedToMissingSenderStructure(structureId) 
            {
                if (this.selectedSendingDesignatedPerson != null && this.selectedSendingDesignatedPerson.structureId != structureId)
                    this.selectedSendingDesignatedPerson = null;
            },
            deletePersons_RelatedToMissingRecipientStructures(structureIds) 
            {
                if (this.categoryId == 1)
                    this.selectedRecipientDesignatedPersons = null;
                else
                    this.selectedRecipientDesignatedPersons = this.selectedRecipientDesignatedPersons.filter(person => !structureIds.has(person.structureId));
            },
            deleteDuplicatedPersons_PerRecipientStructure(list = []) 
            {  
                let newPerson = list.find(item => !item.Added && item.id > 0);
                if (newPerson != null && newPerson != undefined) 
                {
                    let newPersonStructureId = newPerson.structureId;
                    let count = 0;
                    for (let i = 0; i < list.length; i++) 
                    {
                        if (list[i].structureId == newPersonStructureId)
                            count++;
                    }
                    if (count > 1) 
                    {
                        list = list.filter(item => item.structureId != newPersonStructureId);
                        list.push(newPerson);
                    }
                }
                list = utils.handleFirstElement(list, { id: -1, name: 'temp' });
                return list;
            },
            afterMapping() 
            {
                if (this.categoryId != 1) 
                {
                    this.selectedRecipientDesignatedPersons = utils.handleFirstElement(this.selectedRecipientDesignatedPersons, { id: -1, name: 'temp' });
                    if (this.selectedRecipientDesignatedPersons.length == 1 && this.selectedRecipientDesignatedPersons[0].id == -1)
                        this.selectedRecipientDesignatedPersons = [];

                    this.selectedRecipientStructures = utils.handleFirstElement(this.selectedRecipientStructures, { id: -1, name: 'temp' });
                    if (this.selectedRecipientStructures.length == 1 && this.selectedRecipientStructures[0].id == -1)
                        this.selectedRecipientStructures = [];
                }
            },
            prepareRecipientDesignatedPersonsObject() 
            { 
                const result = [];
                if (this.categoryId == 1) 
                {
                    result.push({
                        structureId: this.selectedRecipientStructures != null ? this.selectedRecipientStructures.id : null,
                        designatedPersonId: this.selectedRecipientDesignatedPersons != null ? this.selectedRecipientDesignatedPersons.id : null
                    });
                }
                else 
                {
                    let Structures = this.selectedRecipientStructures.filter(item => item.id > 0);
                    let Persons = this.selectedRecipientDesignatedPersons.filter(item => item.id > 0);

                    for (let structure of Structures) 
                    {
                        const designatedPersonMatch = Persons.find(person => person.structureId == structure.id);
                        result.push({
                            structureId: structure.id,
                            designatedPersonId: designatedPersonMatch ? designatedPersonMatch.id : null
                        });
                    }
                }
                return result;
            },
            CapitalizeFirstLetter(str) 
            {
                return utils.CapitalizeFirstLetter(str)
            },
            exportData() 
            {
                let exportedData = {
                    selectedSenderStructureId: this.selectedSenderStructure != null ? this.selectedSenderStructure.id : null,
                    selectedSendingDesignatedPersonId: this.selectedSendingDesignatedPerson != null ? this.selectedSendingDesignatedPerson.id : null,
                    compoRecipientDesignatedPersons: this.prepareRecipientDesignatedPersonsObject()
                };
                this.$emit('exportedData', exportedData);
            },
            // ------------------- Designated Persons Dialog Methods ----------------- //
            openDesignatedPersonsDetailsDialog(forStructure) 
            {
                this.forStructureDialogMode = forStructure;
                this.getDesignatedPersonsForDialog(this.forStructureDialogMode);
                //this.allSelectedDesignatedPersonsCheckbox = [];
                this.showDesignatedPersonsDetailsDialog = true;
            },
            getDesignatedPersonsForDialog(forStructure)
            {
                let strIds = [];
                let InternalExternalBothCase = this.handleInternalExternalDesignatedPersonsCases(forStructure);
                if (forStructure == 'Sender') 
                {
                    this.dialogMode = 1;
                    strIds = this.selectedSenderStructure != null ? [Number(this.selectedSenderStructure.id)] : [];
                    this.getDesignatedPersons('dialogMode', '', strIds, false, [], false, InternalExternalBothCase, true,true);
                }
                else if (forStructure == 'Recipient') 
                {
                    this.dialogMode = 2;
                    strIds = this.categoryId != 1 ? this.selectedRecipientStructures.filter(item => item.id > 0).map(i => Number(i.id)) : [this.selectedRecipientStructures.id];
                    this.getDesignatedPersons('dialogMode', '', strIds, false, [], false, InternalExternalBothCase, true,true);
                }
            },
            handleDialogData(response, ignoreReset = this.ignoreReset) 
            {   
                this.dialogDesignatedPersonsList = response;
                var per=this.selectedRecipientDesignatedPersons;

                if (this.dialogMode == 1)
                    this.dialogStructuresList = this.selectedSenderStructure != null ? [this.selectedSenderStructure] : [];
                else if (this.dialogMode == 2)
                    this.dialogStructuresList = this.categoryId == 1 ? [this.selectedRecipientStructures] : this.selectedRecipientStructures.filter(x => x.id > 0);
               
              
              this.selectedRecipientDesignatedPersons.forEach(selPerson => {
                    const dilPerson = this.dialogDesignatedPersonsList.find(dilPerson => dilPerson.id === selPerson.id);
                    
                    if (dilPerson) {
                       dilPerson.isSelected = true; // Set isSelected to true
                       this.allSelectedDesignatedPersonsCheckbox.push(dilPerson);
                    }
                });

                if (!ignoreReset)
                {
                    // For Structures
                    this.dialogStructuresList.map((str) => { str.isOpen = false });
                    // For Persons
                  // this.dialogDesignatedPersonsList.forEach(person => { person.isSelected = false })
                }
            },
            showAddEditDialog(stucture, structureId) 
            {
                if (stucture != null && stucture != undefined) 
                {
                    this.addEditResource = this.$t("res_DialogTitle_EditDesignatedPerson");
                    this.designatedPerson = { ...stucture };
                }
                else 
                {
                    this.addEditResource = this.$t("res_DialogTitle_AddDesignatedPerson");
                    this.designatedPerson.structureId = structureId
                }
                this.showAddEditDesignatedPersonDialog = true;
            },
            addEditDesignatedPerson() 
            {
                if (this.designatedPerson.firstName == "" || this.designatedPerson.lastName == "" ) 
                {
                    window.showAlert('res_Msgs_FillRequired', 'warning');
                    return;
                }

                const isValidEmail = /^((?!@)[\w!#$%&'*+\/=?^_`{|}~-]+(\.[\w!#$%&'*+\/=?^_`{|}~-]+)*)([\w!#$%&'*+\/=?^_`{|}~-]+(\.[\w!#$%&'*+\/=?^_`{|}~-]+)*)?@((?!@)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*)(\.[a-zA-Z]{2,})$/.test(this.designatedPerson.email);
                if (!isValidEmail && this.designatedPerson.email != "") 
                {
                    window.showAlert(this.$t("res_Msgs_InvalidEmail"), 'warning')
                    return;
                }

                utils.defaultPost('Document/AddEditDesignatedPerson', this.designatedPerson,
                    (res) => 
                    {
                        if (res.data > 0) {
                            window.showAlert('res_Msgs_DesignatedAddSuccess', 'success');
                            this.ignoreReset = true;
                            this.getDesignatedPersonsForDialog(this.forStructureDialogMode);
                            this.closeAddEditDesignatedPersonsDialog();
                        }
                    },
                    this.handleError, true);
            },
            handleDesignatedPersonCheckboxClick(designatedPerson) 
            {
                if (this.dialogMode == 1) 
                {
                    if (designatedPerson.isSelected) 
                    {
                        // UnCheck Rest of other Persons ..
                        this.dialogDesignatedPersonsList.forEach(person => 
                        {
                            if (person.id != designatedPerson.id)
                                person.isSelected = false
                        });
                        this.allSelectedDesignatedPersonsCheckbox = [designatedPerson];
                    }
                    else
                        this.allSelectedDesignatedPersonsCheckbox = [];
                }
                else if (this.dialogMode == 2) 
                {
                    if (designatedPerson.isSelected) 
                    {
                        // UnCheck Rest of other Persons that Related to Same Structure..
                        let structureId = designatedPerson.structureId;
                        this.allSelectedDesignatedPersonsCheckbox = this.allSelectedDesignatedPersonsCheckbox.filter(person => person.structureId != structureId);
                        this.dialogDesignatedPersonsList.forEach(person => {
                            if (structureId == person.structureId && person.id != designatedPerson.id)
                                person.isSelected = false;
                        });
                        this.allSelectedDesignatedPersonsCheckbox.push(designatedPerson);
                    }else{ this.allSelectedDesignatedPersonsCheckbox=this.allSelectedDesignatedPersonsCheckbox.filter(person=> person.id != designatedPerson.id)}
                }

                this.dialogDesignatedPersonsList = [...this.dialogDesignatedPersonsList];
            },
            saveSelectedDesignatedPersonsDialog() 
            {
                if (this.dialogMode == 1)
                    this.handleSelectedItems('sendingDesignatedPerson', this.allSelectedDesignatedPersonsCheckbox[0]);
                else if (this.dialogMode == 2)
                    this.handleSelectedItems('recipientDesignatedPersons', this.categoryId == 1 ? this.allSelectedDesignatedPersonsCheckbox[0] : this.allSelectedDesignatedPersonsCheckbox);

                this.closeDesignatedPersonsDialog();
            },
            closeAddEditDesignatedPersonsDialog() 
            {
                this.showAddEditDesignatedPersonDialog = false;
                this.designatedPerson = {};
            },
            closeDesignatedPersonsDialog() 
            {
                this.forStructureDialogMode = '';
                this.showDesignatedPersonsDetailsDialog = false;
                this.allSelectedDesignatedPersonsCheckbox = [];
                this.dialogDesignatedPersonsList = [];
                this.dialogStructuresList = [];
                this.ignoreReset = false;
            },
            doesStructureHavePersons(structureId) 
            {
                return this.dialogDesignatedPersonsList.some(person => person.structureId == structureId);
            },
            openStructure(index) 
            {
                this.$set(this.dialogStructuresList[index], 'isOpen', !this.dialogStructuresList[index].isOpen);
                this.dialogStructuresList = [...this.dialogStructuresList]; // Solving Binding Issue in Vue js
            },

     openDeleteDialog(item) {

			window.showInformation(this.$t('res_Label_Alert'), this.$t("res_Msgs_DeletConfirmation"),
				() => {
					axios.get(constants.baseApiUrl + "Document/DeleteDesignatedPerson?userId=" + item.userId+"&&structureUserId="+item.id)
						.then((res) => 
                         {
                            if (res.data > 0) {
                                window.showAlert('res_Msgs_DesignatedAddSuccess', 'success');
                                this.ignoreReset = true;
                                this.getDesignatedPersonsForDialog(this.forStructureDialogMode);
                            }
                         }
                       
                        )
						.catch((err) => console.log(err));
				},
				() => { })
		},
        }
    }
</script>

<style scoped>
    .icon-button {
        width: 24px; /* Adjust the width as needed */
        /* You can also add other styling properties as per your design */
    }

    .text-cut {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 100%;
    }

    .bg-gray {
        background-color: #E7EBEF;
    }

    ::v-deep .class1 {
        margin-top: 10px;
    }
</style>